<div class="flex items-center mb-4">
  <h6 class="uppercase flex-none mr-4">{{ title }}</h6>
  <div
    class="bg-foreground rounded-full border-2 px-4 max-w-[300px] flex-1 flex items-center"
  >
    <mat-icon svgIcon="mat:search" size="20px"></mat-icon>
    <input
      [formControl]="searchCtrl"
      class="px-4 py-2 border-0 outline-none w-full bg-transparent"
      [placeholder]="searchPlaceholder"
      type="search"
    />
  </div>
</div>

<div class="virtual-tree flex flex-col relative">
  <cdk-virtual-scroll-viewport
    #scrollableTree
    [itemSize]="48"
    class="tree-viewport"
  >
    <ng-container *cdkVirtualFor="let node of dataSource">
      <div [style.padding-left]="node.level * 20 + 'px'" class="tree-node">
        <red-virtual-tree-item [node]="node"></red-virtual-tree-item>
      </div>
    </ng-container>
  </cdk-virtual-scroll-viewport>
</div>
